var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RedButton',{attrs:{"title":"振替日を確認する"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('TransferIcon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }